// extracted by mini-css-extract-plugin
export default {"Box":"iteration-renderer-module__Box--HhmLT","Label":"iteration-renderer-module__Label--EFJVi"};